
import React from 'react';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '@/components/ui/table';
import { CreateSundayMarketPriceInput } from '@/types/database/sunday-market-prices';

interface SundayMarketPreviewTableProps {
  data: CreateSundayMarketPriceInput[];
  maxRows?: number;
}

const SundayMarketPreviewTable: React.FC<SundayMarketPreviewTableProps> = ({ 
  data, 
  maxRows = 5 
}) => {
  const displayData = maxRows ? data.slice(0, maxRows) : data;

  return (
    <div className="space-y-3">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Preview Data</h3>
        <span className="text-sm text-gray-600">
          Showing {displayData.length} of {data.length} records
        </span>
      </div>
      
      <div className="border rounded-lg overflow-hidden">
        <div className="max-h-96 overflow-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Date</TableHead>
                <TableHead>Product Name</TableHead>
                <TableHead>Price</TableHead>
                <TableHead>Location</TableHead>
                <TableHead>Product Remark</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {displayData.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.date}</TableCell>
                  <TableCell>{item.product_name}</TableCell>
                  <TableCell>{item.price.toFixed(2)}</TableCell>
                  <TableCell>{item.location}</TableCell>
                  <TableCell>{item.product_remark || '-'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
      
      {data.length > maxRows && (
        <p className="text-sm text-gray-600 text-center">
          {data.length - maxRows} more records will be uploaded...
        </p>
      )}
    </div>
  );
};

export default SundayMarketPreviewTable;
